import React from 'react';
import { comparacionTerminada } from './comparacion';
import { formatearUsd } from './metricas';
import type { ComparacionIA } from './tipos';
import { ChipStatus, btnPrimario, formatearFecha, inputCls } from './ui';

/**
 * Lanzar "Comparar con IA" (modelo + botón + cuántos casos tienen referencia), el estado
 * de la comparación en curso y las anteriores con las MISMAS corridas.
 */
const PanelComparacionIA: React.FC<{
  modelos: string[];
  modelo: string;
  onModelo: (m: string) => void;
  casosTotal: number;
  casosConReferencia: number;
  lanzando: boolean;
  onLanzar: () => void;
  comparacion: ComparacionIA | null;
  anteriores: ComparacionIA[];
  onAbrir: (id: string) => void;
}> = ({ modelos, modelo, onModelo, casosTotal, casosConReferencia, lanzando, onLanzar, comparacion, anteriores, onAbrir }) => {
  const enCurso = comparacion !== null && !comparacionTerminada(comparacion);
  const puede = !lanzando && !enCurso && casosConReferencia > 0 && casosTotal > 0;
  return (
    <div className="space-y-2 rounded-xl border border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center gap-3">
        <label className="flex items-center gap-2 text-xs text-gray-500">
          Modelo
          <select value={modelo} onChange={(e) => onModelo(e.target.value)} className={inputCls}>
            {modelos.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>
        <button type="button" onClick={onLanzar} disabled={!puede} className={btnPrimario} title="Un modelo lee tu análisis y el de cada corrida, caso por caso">
          {lanzando ? 'Encolando…' : 'Comparar con IA'}
        </button>
        <span className="text-xs text-gray-500">
          <b className={casosConReferencia > 0 ? 'text-brand-black' : 'text-red-600'}>{casosConReferencia}</b> de {casosTotal} casos tienen tu análisis
          {casosConReferencia === 0 && ' · escribí al menos uno abajo'}
        </span>
        {comparacion && (
          <span className="ml-auto flex items-center gap-2 text-xs text-gray-500">
            {enCurso && (
              <span className="flex items-center gap-2 text-blue-600">
                <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
                Comparando {comparacion.imagen_ids.length} casos…
              </span>
            )}
            <ChipStatus status={comparacion.status} />
            {comparacion.modelo} · {formatearFecha(comparacion.created_at)}
            {comparacion.cost_usd !== null && ` · ${formatearUsd(comparacion.cost_usd)}`}
          </span>
        )}
      </div>
      {anteriores.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="text-gray-500">Anteriores con estas corridas:</span>
          {anteriores.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => onAbrir(c.id)}
              className={`rounded-full border py-1 px-2.5 ${comparacion?.id === c.id ? 'border-brand-black bg-brand-black text-white' : 'border-gray-300 bg-white text-brand-black hover:border-gray-500'}`}
            >
              {formatearFecha(c.created_at)} · {c.modelo} · {c.imagen_ids.length} casos
              {c.error ? ' · con error' : ''}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PanelComparacionIA;
